// //@ts-nocheck
// import { useEffect, useRef, useState } from 'react';
// import axios from 'axios';
// import { Room, LocalAudioTrack, RoomEvent, DataPacket_Kind } from 'livekit-client';
// import CallControlBar from 'src/onboarding/components/ui/Callcontrolbar/Callcontrolbar';
// import s from './style.module.scss';
// import { Typography } from 'src/onboarding/components/typography-voery/Typography';
// import { Modal } from 'src/onboarding/components/ui/modal/Modal';
// import VoeryApp from '../../assets/images/voeryAppIcon.png';
// import Button from 'src/onboarding/components/ui/button/Button';
// import { t } from '@web-solutions/module-localization';
// import Loader from 'src/onboarding/components/ui/loader';
// import { useToast } from 'src/onboarding/hooks/useToast';
// import { Toast } from 'src/onboarding/components/ui/Toast/Toast';

// export default function VoeryCallPage() {
//   const roomMyRef = useRef(null);
//   const roomOtherRef = useRef(null);
//   const mediaStreamRef = useRef(null);
//   const translatedAudioRef = useRef(null);
//   const originalAudioRef = useRef(null);
//   const originalAudioElementRef = useRef(null);
//   const chatBottomRef = useRef<HTMLDivElement>(null);
//   const messageBufferRef = useRef<Record<string, any>>({});

//   const [callUuid, setCallUuid] = useState('');
//   const [isConnected, setIsConnected] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [messages, setMessages] = useState([]);
//   const [error, setError] = useState('');
//   const [myIdentity, setMyIdentity] = useState('');
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isOnline, setIsOnline] = useState(navigator.onLine);
//   const { toasts, show, remove } = useToast();
//   const offlineToastIdRef = useRef<string | null>(null);

//   const API_BASE = 'https://stage-api.voery.app';

//   const cleanup = async () => {
//     try {
//       if (roomMyRef.current) {
//         await roomMyRef.current.disconnect();
//         roomMyRef.current = null;
//       }
//       if (roomOtherRef.current) {
//         await roomOtherRef.current.disconnect();
//         roomOtherRef.current = null;
//       }
//       if (mediaStreamRef.current) {
//         mediaStreamRef.current.getTracks().forEach((t) => t.stop());
//         mediaStreamRef.current = null;
//       }
//       if (originalAudioElementRef.current) {
//         originalAudioElementRef.current.pause();
//         originalAudioElementRef.current.srcObject = null;
//         originalAudioElementRef.current = null;
//       }
//       translatedAudioRef.current = null;
//       originalAudioRef.current = null;
//       messageBufferRef.current = {};
//       setIsConnected(false);
//       setIsModalOpen(true);
//     } catch (e) {
//       console.error('Cleanup error', e);
//     }
//   };

// useEffect(() => {
//   const handleOffline = () => {
//     setIsOnline(false);
//     offlineToastIdRef.current = show(t('onboarding.voeryCall.noInternet'), 'default', 0); // 0 = не исчезает само
//   };
//   const handleOnline = () => {
//     setIsOnline(true);
//     if (offlineToastIdRef.current) {
//       remove(offlineToastIdRef.current);
//       offlineToastIdRef.current = null;
//     }
//   };

//   window.addEventListener('offline', handleOffline);
//   window.addEventListener('online', handleOnline);
//   return () => {
//     window.removeEventListener('offline', handleOffline);
//     window.removeEventListener('online', handleOnline);
//   };
// }, []);

//   // Auto-scroll on new messages
//   useEffect(() => {
//     chatBottomRef.current?.scrollIntoView({ behavior: 'smooth' });
//   }, [messages]);

//   const handleConnect = async () => {
//     if (!callUuid.trim()) {
//       setError('Введите callUuid');
//       return;
//     }

//     setError('');
//     setLoading(true);
//     setMessages([]);
//     await cleanup();

//     try {
//       const { data } = await axios.get(`${API_BASE}/palabra/session/call/${callUuid.trim()}`);

//       if (!data.success || !data.sessions?.length) {
//         setError('Сессии не найдены');
//         setLoading(false);
//         return;
//       }

//       const sessions = data.sessions;
//       const mySession = sessions.find((s) => !s.isCreator);
//       const otherSession = sessions.find((s) => s.isCreator);

//       const roomMy = new Room();
//       const roomOther = new Room();
//       roomMyRef.current = roomMy;
//       roomOtherRef.current = roomOther;

//       // ─── PUBLISHER ROOM ───────────────────────────────────────────────────

//       roomMy.on(RoomEvent.TrackPublished, async (publication) => {
//         if (publication.kind === 'audio' && publication.isSubscribed) {
//           await publication.unsubscribe();
//         }
//       });

//       roomMy.on(RoomEvent.TrackSubscribed, async (track, publication) => {
//         if (track.kind === 'audio') {
//           track.stop?.();
//           await publication.unsubscribe();
//         }
//       });

//       roomMy.on(RoomEvent.Disconnected, (reason) => {
//         console.log('[roomMy] DISCONNECTED:', reason);
//       });

//       // ─── SUBSCRIBER ROOM ──────────────────────────────────────────────────

//       roomOther.on(RoomEvent.TrackPublished, async (publication) => {
//         if (publication.kind === 'audio') {
//           await publication.subscribe();
//         }
//       });

//       roomOther.on(RoomEvent.TrackSubscribed, (track, _publication, participant) => {
//         if (track.kind !== 'audio') return;
//         const identity = participant.identity;
//         const audio = new Audio();
//         audio.srcObject = new MediaStream([track.mediaStreamTrack]);

//         if (identity.includes('palabra')) {
//           translatedAudioRef.current = track;
//           audio.play().catch(console.error);
//         } else {
//           originalAudioRef.current = track;
//           audio.muted = true;
//           originalAudioElementRef.current = audio;
//         }
//       });

//       await roomMy.connect(mySession.webrtcUrl, mySession.publisher, { autoSubscribe: false });
//       setMyIdentity(roomMy.localParticipant?.identity || '');

//       await roomOther.connect(otherSession.webrtcUrl, otherSession.subscriber, {
//         autoSubscribe: true,
//       });

//       setIsConnected(true);

//       // ─── Microphone ───────────────────────────────────────────────────────
//       const stream = await navigator.mediaDevices.getUserMedia({ audio: { channelCount: 1 } });
//       mediaStreamRef.current = stream;
//       const localTrack = new LocalAudioTrack(stream.getAudioTracks()[0]);
//       await roomMy.localParticipant.publishTrack(localTrack, { dtx: false, red: false });

//       const handleData = (payload, participant, isPublisher: boolean) => {
//         try {
//           const decoded = new TextDecoder().decode(payload);
//           const msg = JSON.parse(decoded);
//           if (!msg.message_type) return;

//           // isPublisher room = мои сообщения, subscriber room = собеседник
//           const side = isPublisher ? 'me' : 'remote';

//           switch (msg.message_type) {
//             case 'partial_transcription': {
//               const t = msg.data?.transcription;
//               if (!t?.transcription_id || !t?.text) return;
//               // Только сохраняем в буфер — НЕ показываем бабл (как в Flutter)
//               messageBufferRef.current[t.transcription_id] = {
//                 transcriptionId: t.transcription_id,
//                 side,
//                 original: t.text,
//                 translated: null,
//                 isPartial: true,
//               };
//               break;
//             }

//             case 'validated_transcription': {
//               const t = msg.data?.transcription;
//               if (!t?.transcription_id || !t?.text) return;
//               const existing = messageBufferRef.current[t.transcription_id];
//               messageBufferRef.current[t.transcription_id] = {
//                 ...(existing ?? { transcriptionId: t.transcription_id, side, translated: null }),
//                 original: t.text,
//                 isPartial: false,
//               };
//               break;
//             }

//             case 'translated_transcription': {
//               const t = msg.data?.transcription;
//               if (!t?.transcription_id || !t?.text) return;
//               const existing = messageBufferRef.current[t.transcription_id];
//               const finalMsg = {
//                 id: t.transcription_id,
//                 side: existing?.side ?? side,
//                 original: existing?.original ?? '',
//                 translated: t.text,
//               };
//               messageBufferRef.current[t.transcription_id] = finalMsg;

//               // Только здесь добавляем/обновляем бабл — как в Flutter _unifiedController.add(msg)
//               setMessages((prev) => {
//                 const idx = prev.findIndex((m) => m.id === t.transcription_id);
//                 if (idx !== -1) {
//                   const updated = [...prev];
//                   updated[idx] = finalMsg;
//                   return updated;
//                 }
//                 return [...prev, finalMsg];
//               });
//               break;
//             }

//             default:
//               break;
//           }
//         } catch (e) {
//           console.error('Data parse error', e);
//         }
//       };

//       roomMy.on(RoomEvent.DataReceived, (payload, participant) => {
//         handleData(payload, participant, true); // isPublisher = true = мои
//       });
//       roomOther.on(RoomEvent.DataReceived, (payload, participant) => {
//         handleData(payload, participant, false); // isPublisher = false = собеседник
//       });

//       // ─── set_task ─────────────────────────────────────────────────────────
//       const setTaskMessage = {
//         message_type: 'set_task',
//         data: {
//           input_stream: { content_type: 'audio', source: { type: 'webrtc' } },
//           output_stream: { content_type: 'audio', target: { type: 'webrtc' } },
//           pipeline: {
//             transcription: { source_language: mySession.sourceLanguage.code },
//             translations: [
//               {
//                 target_language: mySession.targetLanguage.code,
//                 translate_partial_transcriptions: true,
//                 speech_generation: { voice_id: 'default_low' },
//               },
//             ],
//             segment_confirmation_silence_threshold: 0.5,
//             // ✅ Добавили как в Flutter — запрашиваем все 3 типа
//             allowed_message_types: [
//               'partial_transcription',
//               'validated_transcription',
//               'translated_transcription',
//             ],
//           },
//         },
//       };

//       const taskPayload = new TextEncoder().encode(JSON.stringify(setTaskMessage));
//       await roomMy.localParticipant.publishData(
//         taskPayload,
//         DataPacket_Kind.RELIABLE,
//         'palabra:set_task'
//       );
//     } catch (e) {
//       console.error(e);
//       setError('Ошибка подключения');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // useEffect(
//   //   () => () => {
//   //     cleanup();
//   //   },
//   //   []
//   // );

//   const handleNextStep = () => {
//     window.open('https://onelink.to/4pqrsh', '_blank');
//   };

//   return (
//     <>
//       <div className={s.page}>
//         {/* ── UUID connect bar ── */}
//         <div className={s.connectSection}>
//           <input
//             value={callUuid}
//             onChange={(e) => setCallUuid(e.target.value)}
//             onKeyDown={(e) => e.key === 'Enter' && !loading && handleConnect()}
//             placeholder='Call UUID'
//             disabled={isConnected}
//             className={s.uuidInput}
//           />
//           {!isConnected ? (
//             <button onClick={handleConnect} disabled={loading} className={s.connectBtn}>
//               {loading ? 'Connecting…' : 'Connect'}
//             </button>
//           ) : (
//             <button onClick={cleanup} className={`${s.connectBtn} ${s['connectBtn--disconnect']}`}>
//               Disconnect
//             </button>
//           )}
//         </div>

//         {/* ── Chat area ── */}
//         <div className={s.chatArea}>
//           {loading || !isOnline ? (
//             <div className={s.loaderContainer}>
//               <Loader />
//               <Typography variant='h2-bold'>{t('onboarding.voeryCall.connecting')}</Typography>
//             </div>
//           ) : messages.length === 0 ? null : (
//             messages.map((m) => (
//               <div key={m.id} className={`${s.messageRow} ${s[`messageRow--${m.side}`]}`}>
//                 <div className={s.messageGroup}>
//                   <div className={`${s.bubble} ${s[`bubble--${m.side}`]}`}>
//                     {m.original && (
//                       <Typography
//                         variant='callout-medium'
//                         className={`${s.originalText} ${s[`originalText--${m.side}`]}`}
//                       >
//                         {m.original}
//                       </Typography>
//                     )}
//                     {m.translated && (
//                       <Typography variant='body-semibold' className={s.translatedText}>
//                         {m.translated}
//                       </Typography>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             ))
//           )}
//           <div ref={chatBottomRef} />
//         </div>

//         {/* ── Call controls ── */}
//         <div className={s.controlBarWrapper}>
//           <CallControlBar
//             callActive={isConnected}
//             muted={false}
//             speaker={false}
//             onEndCall={cleanup}
//             onToggleMute={() => {}}
//             onToggleSpeaker={() => {}}
//           />
//         </div>
//         <Toast toasts={toasts} onRemove={remove} />

//       </div>

//       <Modal isOpen={isModalOpen} className={s.modalCall}>
//         <div className={s.modalContent}>
//           <img src={VoeryApp} alt='Voery app Icon' />

//           <div className={s.modalText}>
//             <Typography variant='h1-bold'>{t('onboarding.voeryCall.modal.title')}</Typography>
//             <Typography variant='body-semibold'>
//               {t('onboarding.voeryCall.modal.subTitle')}
//             </Typography>
//           </div>
//           <Button title={t('onboarding.voeryCall.modal.downloadApp')} onClick={handleNextStep} />
//         </div>
//       </Modal>
//     </>
//   );
// }

//@ts-nocheck
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Room, LocalAudioTrack, RoomEvent, DataPacket_Kind } from 'livekit-client';
import CallControlBar from 'src/onboarding/components/ui/Callcontrolbar/Callcontrolbar';
import s from './style.module.scss';
import { Typography } from 'src/onboarding/components/typography-voery/Typography';
import { Modal } from 'src/onboarding/components/ui/modal/Modal';
import VoeryApp from '../../assets/images/voeryAppIcon.png';
import Button from 'src/onboarding/components/ui/button/Button';
import { t } from '@web-solutions/module-localization';
import Loader from 'src/onboarding/components/ui/loader';
import { useToast } from 'src/onboarding/hooks/useToast';
import { Toast } from 'src/onboarding/components/ui/Toast/Toast';
import { MicrophoneOffIcon } from 'src/onboarding/assets/icons/MicrophoneOffIcon';

const CALL_ENDED_KEY = 'voery_call_ended';

export default function VoeryCallPage() {
  const roomMyRef = useRef(null);
  const roomOtherRef = useRef(null);
  const mediaStreamRef = useRef(null);
  const translatedAudioRef = useRef(null);
  const originalAudioRef = useRef(null);
  const originalAudioElementRef = useRef(null);
  const chatBottomRef = useRef<HTMLDivElement>(null);
  const messageBufferRef = useRef<Record<string, any>>({});
  const offlineToastIdRef = useRef<string | null>(null);
  const muteToastIdRef = useRef<string | null>(null);
  const mutedRef = useRef(false);

  const [callUuid, setCallUuid] = useState('');
  const [isConnected, setIsConnected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [error, setError] = useState('');
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [muted, setMuted] = useState(false);
  const [speaker, setSpeaker] = useState(false);

  // ── Modals ────────────────────────────────────────────────────────────────────
  const [isCallEndedModalOpen, setIsCallEndedModalOpen] = useState(false);
  const [isMicDeniedModalOpen, setIsMicDeniedModalOpen] = useState(false);

  const { toasts, show, remove } = useToast();

  const API_BASE = 'https://stage-api.voery.app';

  // ── 2) При монтировании: показать модал если звонок уже был завершён,
  //       НО только если в URL нет нового callUuid ─────────────────────────────
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const uuidFromUrl = params.get('callUuid') || params.get('uuid') || params.get('call_uuid');

    if (uuidFromUrl) {
      // Новая ссылка на звонок — сбрасываем флаг и подставляем UUID
      localStorage.removeItem(CALL_ENDED_KEY);
      setCallUuid(uuidFromUrl);
    } else if (localStorage.getItem(CALL_ENDED_KEY) === 'true') {
      // Звонок был завершён ранее — сразу показываем модал
      setIsCallEndedModalOpen(true);
    }
  }, []);

  // ── Online/offline ────────────────────────────────────────────────────────────
  useEffect(() => {
    const handleOffline = () => {
      setIsOnline(false);
      offlineToastIdRef.current = show(t('onboarding.voeryCall.noInternet'), 'default', 0);
    };
    const handleOnline = () => {
      setIsOnline(true);
      if (offlineToastIdRef.current) {
        remove(offlineToastIdRef.current);
        offlineToastIdRef.current = null;
      }
    };
    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  // Auto-scroll
  useEffect(() => {
    chatBottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  // ── Cleanup ───────────────────────────────────────────────────────────────────
  const cleanup = async (showEndToast = false) => {
    try {
      if (roomMyRef.current) {
        await roomMyRef.current.disconnect();
        roomMyRef.current = null;
      }
      if (roomOtherRef.current) {
        await roomOtherRef.current.disconnect();
        roomOtherRef.current = null;
      }
      if (mediaStreamRef.current) {
        mediaStreamRef.current.getTracks().forEach((t) => t.stop());
        mediaStreamRef.current = null;
      }
      if (originalAudioElementRef.current) {
        originalAudioElementRef.current.pause();
        originalAudioElementRef.current.srcObject = null;
        originalAudioElementRef.current = null;
      }
      translatedAudioRef.current = null;
      originalAudioRef.current = null;
      messageBufferRef.current = {};
      setIsConnected(false);
      setMuted(false);
      setSpeaker(false);

      if (showEndToast) {
        localStorage.setItem(CALL_ENDED_KEY, 'true');
        show(t('onboarding.voeryCall.callOver'), 'default', 3000);
        setTimeout(() => setIsCallEndedModalOpen(true), 3000);
      }
    } catch (e) {
      console.error('Cleanup error', e);
    }
  };

  // ── 3) Mute ───────────────────────────────────────────────────────────────────
  // const handleToggleMute = () => {
  //   const track = roomMyRef.current?.localParticipant?.audioTrackPublications?.values()?.next()
  //     ?.value?.track;

  //   if (!muted) {
  //     // Muting
  //     if (track) track.mediaStreamTrack.enabled = false;
  //     setMuted(true);
  //     muteToastIdRef.current = show(
  //       <span className={s.muted}>
  //         <MicrophoneOffIcon /> {t('onboarding.voeryCall.micMuted')}
  //       </span>,
  //       'default',
  //       0
  //     );
  //   } else {
  //     // Unmuting
  //     if (track) track.mediaStreamTrack.enabled = true;
  //     setMuted(false);
  //     if (muteToastIdRef.current) {
  //       remove(muteToastIdRef.current);
  //       muteToastIdRef.current = null;
  //     }
  //   }
  // };

  const silentTrackRef = useRef<LocalAudioTrack | null>(null);

  const handleToggleMute = async () => {
    const publication = roomMyRef.current?.localParticipant?.audioTrackPublications
      ?.values()?.next()?.value;
  
    if (!muted) {
      mutedRef.current = true;
      // ── Mute: заменяем реальный трек на тишину ──────────────────────────
      const silentStream = new MediaStream([createSilentTrack()]);
      const silentTrack = new LocalAudioTrack(silentStream.getAudioTracks()[0]);
      silentTrackRef.current = silentTrack;
  
      if (publication) {
        await roomMyRef.current?.localParticipant?.unpublishTrack(publication.track);
        await roomMyRef.current?.localParticipant?.publishTrack(silentTrack, { dtx: false, red: false });
      }
  
      setMuted(true);
      muteToastIdRef.current = show(
        <span className={s.muted}>
          <MicrophoneOffIcon /> {t('onboarding.voeryCall.micMuted')}
        </span>,
        'default',
        0
      );
    } else {
      mutedRef.current = false;
      // ── Unmute: возвращаем реальный микрофон ────────────────────────────
      if (silentTrackRef.current) {
        await roomMyRef.current?.localParticipant?.unpublishTrack(silentTrackRef.current);
        silentTrackRef.current.stop();
        silentTrackRef.current = null;
      }
  
      // Переподключаем реальный микрофон
      const stream = await navigator.mediaDevices.getUserMedia({ audio: { channelCount: 1 } });
      mediaStreamRef.current = stream;
      const realTrack = new LocalAudioTrack(stream.getAudioTracks()[0]);
      await roomMyRef.current?.localParticipant?.publishTrack(realTrack, { dtx: false, red: false });
  
      setMuted(false);
      if (muteToastIdRef.current) {
        remove(muteToastIdRef.current);
        muteToastIdRef.current = null;
      }
    }
  };
  
  // Генерирует пустой AudioTrack (полная тишина)
  function createSilentTrack(): MediaStreamTrack {
    const ctx = new AudioContext();
    const oscillator = ctx.createOscillator();
    const dst = oscillator.connect(ctx.createMediaStreamDestination()) as MediaStreamAudioDestinationNode;
    oscillator.start();
    const track = dst.stream.getAudioTracks()[0];
    // Сразу выключаем осциллятор — остаётся тихий трек
    oscillator.stop();
    return track;
  }

  // ── 3) Speaker ────────────────────────────────────────────────────────────────
  const handleToggleSpeaker = () => {
    const newSpeaker = !speaker;
    setSpeaker(newSpeaker);
    if (translatedAudioRef.current) {
      translatedAudioRef.current.mediaStreamTrack.enabled = newSpeaker
        ? true
        : !translatedAudioRef.current.mediaStreamTrack.enabled;
    }
  };

  // ── Connect ───────────────────────────────────────────────────────────────────
  const handleConnect = async () => {
    if (!callUuid.trim()) {
      setError('Введите callUuid');
      return;
    }

    setError('');
    setLoading(true);
    setMessages([]);
    await cleanup();

    try {
      const { data } = await axios.get(`${API_BASE}/palabra/session/call/${callUuid.trim()}`);

      if (!data.success || !data.sessions?.length) {
        setLoading(false);
        return;
      }

      const sessions = data.sessions;
      const mySession = sessions.find((s) => !s.isCreator);
      const otherSession = sessions.find((s) => s.isCreator);

      const roomMy = new Room();
      const roomOther = new Room();
      roomMyRef.current = roomMy;
      roomOtherRef.current = roomOther;

      roomMy.on(RoomEvent.TrackPublished, async (publication) => {
        if (publication.kind === 'audio' && publication.isSubscribed) {
          await publication.unsubscribe();
        }
      });
      roomMy.on(RoomEvent.TrackSubscribed, async (track, publication) => {
        if (track.kind === 'audio') {
          track.stop?.();
          await publication.unsubscribe();
        }
      });
      roomMy.on(RoomEvent.Disconnected, (reason) => {
        console.log('[roomMy] DISCONNECTED:', reason);
      });

      roomOther.on(RoomEvent.TrackPublished, async (publication) => {
        if (publication.kind === 'audio') {
          await publication.subscribe();
        }
      });
      roomOther.on(RoomEvent.TrackSubscribed, (track, _publication, participant) => {
        if (track.kind !== 'audio') return;
        const identity = participant.identity;
        const audio = new Audio();
        audio.srcObject = new MediaStream([track.mediaStreamTrack]);

        if (identity.includes('palabra')) {
          translatedAudioRef.current = track;
          audio.play().catch(console.error);
        } else {
          originalAudioRef.current = track;
          audio.muted = true;
          originalAudioElementRef.current = audio;
        }
      });

      await roomMy.connect(mySession.webrtcUrl, mySession.publisher, { autoSubscribe: false });
      await roomOther.connect(otherSession.webrtcUrl, otherSession.subscriber, {
        autoSubscribe: true,
      });

      setIsConnected(true);

      // ── 4) Microphone — ловим отказ в разрешении ───────────────────────────
      let stream: MediaStream;
      try {
        stream = await navigator.mediaDevices.getUserMedia({ audio: { channelCount: 1 } });
      } catch (err: any) {
        if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
          setIsMicDeniedModalOpen(true);
          setLoading(false);
          return;
        }
        throw err;
      }

      mediaStreamRef.current = stream;
      const localTrack = new LocalAudioTrack(stream.getAudioTracks()[0]);
      await roomMy.localParticipant.publishTrack(localTrack, { dtx: false, red: false });

      const handleData = (payload, participant, isPublisher: boolean) => {
        try {
          if (isPublisher && mutedRef.current) return;
          const decoded = new TextDecoder().decode(payload);
          const msg = JSON.parse(decoded);
          if (!msg.message_type) return;

          const side = isPublisher ? 'me' : 'remote';

          switch (msg.message_type) {
            case 'partial_transcription': {
              const tr = msg.data?.transcription;
              if (!tr?.transcription_id || !tr?.text) return;
              messageBufferRef.current[tr.transcription_id] = {
                transcriptionId: tr.transcription_id,
                side,
                original: tr.text,
                translated: null,
                isPartial: true,
              };
              break;
            }
            case 'validated_transcription': {
              const tr = msg.data?.transcription;
              if (!tr?.transcription_id || !tr?.text) return;
              const existing = messageBufferRef.current[tr.transcription_id];
              messageBufferRef.current[tr.transcription_id] = {
                ...(existing ?? { transcriptionId: tr.transcription_id, side, translated: null }),
                original: tr.text,
                isPartial: false,
              };
              break;
            }
            case 'translated_transcription': {
              const tr = msg.data?.transcription;
              if (!tr?.transcription_id || !tr?.text) return;
              const existing = messageBufferRef.current[tr.transcription_id];
              const finalMsg = {
                id: tr.transcription_id,
                side: existing?.side ?? side,
                original: existing?.original ?? '',
                translated: tr.text,
              };
              messageBufferRef.current[tr.transcription_id] = finalMsg;
              setMessages((prev) => {
                const idx = prev.findIndex((m) => m.id === tr.transcription_id);
                if (idx !== -1) {
                  const updated = [...prev];
                  updated[idx] = finalMsg;
                  return updated;
                }
                return [...prev, finalMsg];
              });
              break;
            }
            default:
              break;
          }
        } catch (e) {
          console.error('Data parse error', e);
        }
      };

      roomMy.on(RoomEvent.DataReceived, (payload, participant) => {
        handleData(payload, participant, true);
      });
      roomOther.on(RoomEvent.DataReceived, (payload, participant) => {
        handleData(payload, participant, false);
      });

      const setTaskMessage = {
        message_type: 'set_task',
        data: {
          input_stream: { content_type: 'audio', source: { type: 'webrtc' } },
          output_stream: { content_type: 'audio', target: { type: 'webrtc' } },
          pipeline: {
            transcription: { source_language: mySession.sourceLanguage.code },
            translations: [
              {
                target_language: mySession.targetLanguage.code,
                translate_partial_transcriptions: true,
                speech_generation: { voice_id: 'default_low' },
              },
            ],
            segment_confirmation_silence_threshold: 0.5,
            allowed_message_types: [
              'partial_transcription',
              'validated_transcription',
              'translated_transcription',
            ],
          },
        },
      };

      const taskPayload = new TextEncoder().encode(JSON.stringify(setTaskMessage));
      await roomMy.localParticipant.publishData(
        taskPayload,
        DataPacket_Kind.RELIABLE,
        'palabra:set_task'
      );
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleNextStep = () => {
    window.open('https://onelink.to/4pqrsh', '_blank');
  };

  return (
    <>
      <div className={s.page}>
        {/* ── UUID connect bar ── */}
        <div className={s.connectSection}>
          <input
            value={callUuid}
            onChange={(e) => setCallUuid(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && !loading && handleConnect()}
            placeholder='Call UUID'
            disabled={isConnected}
            className={s.uuidInput}
          />
          {!isConnected ? (
            <button onClick={handleConnect} disabled={loading} className={s.connectBtn}>
              {loading ? 'Connecting…' : 'Connect'}
            </button>
          ) : (
            <button
              onClick={() => cleanup(true)} // ← true = показать тост + модал
              className={`${s.connectBtn} ${s['connectBtn--disconnect']}`}
            >
              Disconnect
            </button>
          )}
        </div>

        {/* ── Chat area ── */}
        <div className={s.chatArea}>
          {loading || !isOnline ? (
            <div className={s.loaderContainer}>
              <Loader />
              <Typography variant='h2-bold'>{t('onboarding.voeryCall.connecting')}</Typography>
            </div>
          ) : messages.length === 0 ? null : (
            messages.map((m) => (
              <div key={m.id} className={`${s.messageRow} ${s[`messageRow--${m.side}`]}`}>
                <div className={s.messageGroup}>
                  <div className={`${s.bubble} ${s[`bubble--${m.side}`]}`}>
                    {m.original && (
                      <Typography
                        variant='callout-medium'
                        className={`${s.originalText} ${s[`originalText--${m.side}`]}`}
                      >
                        {m.original}
                      </Typography>
                    )}
                    {m.translated && (
                      <Typography variant='body-semibold' className={s.translatedText}>
                        {m.translated}
                      </Typography>
                    )}
                  </div>
                </div>
              </div>
            ))
          )}
          <div ref={chatBottomRef} />
        </div>

        {/* ── Call controls ── */}
        <div className={s.controlBarWrapper}>
          <CallControlBar
            callActive={isConnected}
            muted={muted}
            speaker={speaker}
            onEndCall={() => cleanup(true)}
            onToggleMute={handleToggleMute}
            onToggleSpeaker={handleToggleSpeaker}
          />
        </div>

        <Toast toasts={toasts} onRemove={remove} />
      </div>

      {/* ── Модал: звонок завершён ── */}
      <Modal isOpen={isCallEndedModalOpen} className={s.modalCall}>
        <div className={s.modalContent}>
          <img src={VoeryApp} alt='Voery app Icon' />
          <div className={s.modalText}>
            <Typography variant='h1-bold'>{t('onboarding.voeryCall.modal.title')}</Typography>
            <Typography variant='body-semibold'>
              {t('onboarding.voeryCall.modal.subTitle')}
            </Typography>
          </div>
          <Button title={t('onboarding.voeryCall.modal.downloadApp')} onClick={handleNextStep} />
        </div>
      </Modal>

      {/* ── 4) Модал: нет доступа к микрофону ── */}
      <Modal
        isOpen={isMicDeniedModalOpen}
        className={s.modalCallDenied}
      >
        <div className={s.modalDeniedContent}>
          <div className={s.closeBtn} onClick={() => setIsMicDeniedModalOpen(false)}>
            ✕
          </div>
          <div className={s.micDeniedIcon}>
            <MicrophoneOffIcon />
          </div>
          <div className={s.modalText}>
            <Typography variant='h2-bold'>{t('onboarding.voeryCall.micDenied.title')}</Typography>
            <Typography variant='callout-medium'>
              {t('onboarding.voeryCall.micDenied.description')}
            </Typography>
          </div>
          <Button
            title={t('onboarding.voeryCall.micDenied.ok')}
            onClick={() => setIsMicDeniedModalOpen(false)}
          />
        </div>
      </Modal>
    </>
  );
}
